import React, { useState, useEffect,useRef} from "react";
import { BrowserRouter, useHistory } from "react-router-dom";
import axios from "axios";
// Material UI
import {
  Container,
  TextField,
  InputAdornment,
  Button,
  Typography,
} from "@material-ui/core";
import AccountCircleTwoToneIcon from "@material-ui/icons/AccountCircleTwoTone";
import LockTwoToneIcon from "@material-ui/icons/LockTwoTone";

//MessageBox
import LoginMessageBox from "../../components/MessageBox/LoginMessageBox";

//Cookie setter/getter
import {
  add_cookies,
  delete_all_cookies,
  timeZoneChangerWithTime
} from "../../components/Cookies/Cookies";

// Stylesheet
import "./Login.scss";
import { format } from "date-fns";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [userData, setUserData] = useState(false);

  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("empty");
	
	const [msgType, setMsgType] = useState("success");
    const [captchaOn, setCaptchaOn] = useState("");
	//Message Box EOF

	let history = useHistory();
        useEffect(() => {
    checkCaptchaOn();
    captcha();
  }, []);

    const captchaRef = useRef();
      const [captchKey, setCaptchaKey] = useState(null);
  const [token, setToken] = useState("");



      const captcha = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "captcha")
      .then(function (res) {
        setCaptchaKey(res.data.success);
      })
      .catch(function (error) {
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };
    const checkCaptchaOn = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "check_captcha_on")
      .then(function (res) {
        setCaptchaOn(res.data.success);
      })
      .catch(function (error) {
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };


	useEffect(() => { //will disable/enable if fields empty/filled
		if((username !== '') && (password !== '')){
			setBtnDisabled(false);
		}else{
			setBtnDisabled(true);
		}
	}, [username, password]);

    useEffect(() => {
    if (captchKey && window.turnstile) {
      window.turnstile.render(captchaRef.current, { 
        theme: "light",
        sitekey: captchKey,
        callback: (token) => setToken(token),
      });
    }
  }, [captchKey]);

	useEffect(()=> {
		if(userData){ //if state array not empty
			//1.5 = 1 hour and 30minutes == 90mins cookie lifespan
			add_cookies('user_id', userData.user_id, 1.5);
			add_cookies('userrole', userData.get_position_access.position, 1.5);
			// add_cookies('fullname', (userData.firstname + ' ' + userData.middlename + ' ' + userData.lastname), 1.5);
			add_cookies('fullname', userData.name, 1.5);
			add_cookies('branchidno', userData.idno, 1.5);
			add_cookies('main.nav.access', JSON.stringify(userData.get_position_access.access_nav), 1.5);
			add_cookies('content.nav.access', JSON.stringify(userData.get_position_access.access_content_nav), 1.5);
			add_cookies('position_id', JSON.stringify(userData.position_id), 1.5);
			add_cookies('curcode', userData.curcode, 1.5);
			add_cookies('branchtype', userData.is_bc, 1.5);
			add_cookies('branchname', userData.branchname, 1.5);
			//console.log(JSON.stringify(userData.get_position_access.access_content_nav)));
			//console.log('cookies added');
		}
	}, [userData]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      user_login();
    }
  };

	const user_login = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("username", username);
		formData.append("password", password);
    if(captchaOn){
            if (!token) {
        setShowMsgBox(true);
        setMsg("Please check the CAPTCHA.");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
        return;
      } else{
              		await axios.post(process.env.REACT_APP_API_URL+'user_login', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				// 'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
			}
			}).then(function (res) {
				if(res.data.status === 0){
					let message = res.data.message ? res.data.message  : "Invalid username/password"; //fallback value incase message property not found
					setShowMsgBox(true);
					setMsg(message);
					setMsgType("warning");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
					}, 2000)
				}else if(res.data.status ===2 ){
					history.push({
						pathname: "/changepassword",
						state: { username: username}
					      });
					      
				}else if(res.data.data.enabled ===10 ){
					history.push({
						pathname: "/changepassword",
						state: { username: username,istemp:10}
					      });
					      
				}
				else{ 	//success, status == 1
					delete_all_cookies();
					localStorage.clear();
					sessionStorage.clear();


					add_cookies('username', username, 1.5);
					add_cookies('country', res.data.data.country, 1.5);
					setUserData(res.data.data);
					setShowMsgBox(true);
					setMsg("Success");
					setMsgType("success");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
						history.push("/dashboard");
					}, 2000)
				}
		  	}).catch(function (error) {
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
    }
    }else{
      		await axios.post(process.env.REACT_APP_API_URL+'user_login', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				// 'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
			}
			}).then(function (res) {
				if(res.data.status === 0){
					let message = res.data.message ? res.data.message  : "Invalid username/password"; //fallback value incase message property not found
					setShowMsgBox(true);
					setMsg(message);
					setMsgType("warning");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
					}, 2000)
				}else if(res.data.status ===2 ){
					history.push({
						pathname: "/changepassword",
						state: { username: username}
					      });
					      
				}else if(res.data.data.enabled ===10 ){
					history.push({
						pathname: "/changepassword",
						state: { username: username,istemp:10}
					      });
					      
				}
				else{ 	//success, status == 1
					delete_all_cookies();
					localStorage.clear();
					sessionStorage.clear();


					add_cookies('username', username, 1.5);
					add_cookies('country', res.data.data.country, 1.5);
					setUserData(res.data.data);
					setShowMsgBox(true);
					setMsg("Success");
					setMsgType("success");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
						history.push("/dashboard");
					}, 2000)
				}
		  	}).catch(function (error) {
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
    }

	}

	return (
	
				<div className="banner">
			<div className="login">
				<LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<div className="login-fields">
					{/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
					<form action="" autoComplete="off" className="login-form" onKeyPress={handleKeyPress}>
						<div className="login-field-container login-title">
							{/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
								<div className="login-logo-container">
									<div className="login-logo">
									<img src={require('../../../src/logo.png')} alt=""  style={{width:"40px"}}/>
									</div>
									<Typography variant="h6" style={{color:"#339933!important"}}>JC Branches</Typography>
								</div>
								<h2 className="h2" style={{textAlign:"left"}}>Login</h2>
								<Typography className="logo-text">
									Fill in the fields below to login to your
									account
								</Typography>
						</div>
						<div className="login-field-container">
							<TextField
								className="login-field"
								id="input-with-icon-textfield"
								variant="outlined"
								label="Username"
								value={username}
								onChange={(e)=>{setUsername(e.target.value)}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<AccountCircleTwoToneIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
						<div className="login-field-container">
							<TextField
								className="login-field"
								id="input-with-icon-textfield"
								variant="outlined"
								label="Password"
								type="password"
								value={password}
								onChange={(e)=>{setPassword(e.target.value)}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LockTwoToneIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
            <div
                style={{ display: "flex", justifyContent: "center" }}
                ref={captchaRef}
                className="cf-turnstile"
              />
						<div className="login-field-container login-field-button">
								<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{user_login()}}>
									Login
								</Button>
						</div>
					</form>
				</div>
				{/* <div className="login-graphic">
					<img
						src="/images/login.svg"
						alt=""
						className="login-image"
					/>
				</div> */}
      </div>
    </div>
  );
};

export default Login;
